<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>币评论</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions" style="position: static;float: left">

        <el-select v-model="queryData.type" placeholder="请选择">
          <el-option v-for="item in queryTypeList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>

        <el-button
            type="primary"
            @click="handleSearch"
        >搜索
        </el-button>
        <el-button
            type=""
            @click="resetSearch"
        >重置
        </el-button>

      </div>

      <el-table :data="dataList">
        <el-table-column prop="content" label="评论内容" show-overflow-tooltip="true"
                         min-width="120"></el-table-column>
        <el-table-column prop="userId" label="账号"/>
        <el-table-column prop="createdTime" label="发布时间">
            <template slot-scope="scope">
                {{ scope.row.createdTime | moment }}
            </template>
        </el-table-column>
        <el-table-column label="审核状态">
          <template slot-scope="scope">
            <span v-if="scope.row.examineStatus == 0">未审核</span>
            <span v-else-if="scope.row.examineStatus == 1">审核通过</span>
            <span v-else-if="scope.row.examineStatus == 2">审核不通过</span>
          </template>
        </el-table-column>
        <el-table-column prop="examineTime" label="审核时间">
            <template slot-scope="scope">
                {{ scope.row.examineTime | moment }}
            </template>
        </el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">
            {{ scope.row.updateTime | moment }}
          </template>
        </el-table-column>
        <el-table-column prop="examineUserId" label="审核人"/>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary"
                       @click="handlePass(scope.row)">审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 30px"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="queryData.page"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="queryData.size"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total">
      </el-pagination>
    </el-card>

    <el-dialog title="审核评论" :visible.sync="dialogVisible" width="40%" @close="getList"
               :close-on-click-modal="false">
      <div>
        <div style="margin: 0px;align:center">
          <el-radio-group v-model="examineStatusUpdate">
            <el-radio class="radio" label="1">审核通过</el-radio>
            <el-radio class="radio" label="2">审核不通过</el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="statusUpdate">确 定</el-button>
            </span>
    </el-dialog>

  </div>
</template>

<script>
import api from './api'

export default {
  name: 'comment',
  data() {
    return {
      account: '',
      queryTypeList: [
        {label: '全部', value: ''},
        {label: '未审核', value: '0'},
        {label: '审核通过', value: '1'},
        {label: '审核不通过', value: '2'}
      ],
      dataList: [],
      examineStatusUpdate:"1",
      dialogVisible: false,
      dialogVisibleEdit: false,
      dialogVisibleShow: false,
      dataListUser:[],
      showInfo: {},
      taskData: {},
      total: 0,
      total:0,
      queryCondition:{
        pageNo:1
      },
      queryData: {
        type: "",
        pageNum: 1,
        pageSize: 10
      },
      queryData2: {
        pageNum: 1,
        pageSize: 10,
        queryValue: "",
        queryType: "",
        groupId: "",
        groupType: ""
      },
      saveData: {
        name: "",
        email: "",
        notes: ""
      },
      editData: {
        id: 0,
        name: "",
        email: "",
        notes: ""
      }
    };
  },
  computed: {},
  methods: {
    getList() {
      api.commentList(this.queryData).then(res => {
        console.log(res)
          if(this.queryData.type == -1){
              this.queryData.type = "";
          }
        this.dataList = res.data.records;
        this.total = res.data.total;
      })
    },
    handleSearch() {
      this.getList();
    },
    changePage(val){
      this.queryData.pageNum = val;
      this.queryData.pageNum=val;
      api.getUsers(this.queryData2).then(res => {
        console.log(res)
        this.dataListUser = res.data;
      })
    },
    resetSearch() {
      this.queryData.search = "";
      this.getList();
    },
    clearData() {
    },
    statusUpdate() {
      api.update({id: this.editData.id, status: this.examineStatusUpdate}).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.$message.success('操作成功！');
          this.dialogVisible = false;
        } else {
          this.$message.error('操作失败！');
        }
      })
    },
    openCreateTaskDialog() {
      this.dialogVisible = true;
    },
    handlePass(data) {
      this.dialogVisible = true;
      this.editData.id = data.id;
    },
    handleSizeChange(val) {
      this.queryData.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.getList();
    },
    handleShow(rowdata) {
      this.queryData2.pageNum=1;
      this.dialogVisibleShow = true;
      this.showInfo=rowdata;
      this.queryData2.groupId=rowdata.id;
      api.getUsers(this.queryData2).then(res => {
        console.log(res)
        this.dataListUser = res.data;
        this.total = res.data.total;
      })
    },
    getNum(index){
      return (this.queryData2.pageNum-1)*this.queryData2.pageSize + index;
    },
    trimQuery() {
      this.queryData.search = this.queryData.search.replace(/(^\s*)|(\s*$)/g, '')
    }

  },
  created() {
    this.getList();
  }
}
</script>

<style lang="less" scoped>
</style>
